module.exports = __webpack_public_path__ + "static/media/H.E. Mar Joseph.7514b5c5.png";